{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-dei-fs-mfrs_2022-12-31/ssmt-dei-fs-mfrs_2022-12-31_role-010000",
  "definition": "[010000] Filing Information",
  "sheetId": "FilingInformation",
  "label": "Filing Information",
  "controls": [
    {
      "qname": "ssmt-dei:NewCompanyRegistrationNumber",
      "label": "New Company registration number",
      "type": "NewCompanyRegistrationNumber",
      "ui": {
        "control": "text",
        "placeholder": "e.g. 202001012345",
        "inputFilter": "numeric",
        "maxLength": 12,
        "trimLeadingZeros": true
      },
      "required": true,
      "validators": [
        { "name": "required" },
        { "name": "pattern", "patternSource": "type:NewCompanyRegistrationNumber" }
      ],
      "error": {
        "required": "Please enter 12 digit new company registration number.",
        "pattern": "Please enter 12 digit new company registration number."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt-dei:CompanyRegistrationNumber",
      "label": "Company registration number (old/new)",
      "type": "CompanyRegistrationNumber",
      "ui": { "control": "text", "hidden": true },
      "required": false,
      "validators": [
        { "name": "pattern", "patternSource": "type:CompanyRegistrationNumber" }
      ],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt-dei:NameOfReportingEntity",
      "label": "Name of company",
      "type": "String",
      "ui": { "control": "text", "placeholder": "e.g. YYC Advisors Sdn. Bhd.", "maxLength": 255 },
      "required": true,
      "validators": [{ "name": "required" }],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] },
      "error": {
        "required": "Please enter name of company."
      }
    },
    { "qname": "ssmt-dei:FormerNameOfCompany", "label": "Former name of the company", "type": "String", "ui": { "control": "text", "hidden": true }, "required": false, "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },
    { "qname": "ssmt-dei:OriginOfCompany", "label": "Origin of company", "type": "OriginOfCompany", "ui": { "control": "select", "enumSource": "type:OriginOfCompany" }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] },"error": {"required": "Please enter origin of company."}},
    { "qname": "ssmt-dei:StatusOfCompany", "label": "Status of company", "type": "StatusOfCompany", "ui": { "control": "select", "enumSource": "type:StatusOfCompany", "readonly": true, "defaultValue": "Private company" }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },
    {
      "qname": "ssmt-dei:TypeOfCompany",
      "label": "Types of company",
      "type": "TypeOfCompany",
      "ui": {
        "control": "select",
        "enumSource": "type:TypeOfCompany",
        "optionsFilteredBy": {
          "field": "ssmt-dei:OriginOfCompany",
          "mappingSource": "conditional:TypeOfCompanyByOrigin"
        }
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "Please select types of company."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },

    { "qname": "ssmt-dei:ApplicationOfSubmission", "label": "Application of submission", "type": "ApplicationOfSubmissionType", "ui": { "control": "select", "enumSource": "type:ApplicationOfSubmissionType", "readonly": true, "defaultValue": "Ordinary filing" }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },
    {
      "qname": "ssmt-dei:StatutoryDeclarationForRectification",
      "label": "Statutory Declaration for rectification",
      "type": "Date",
      "ui": {
        "control": "date",
        "disabledWhen": {
          "field": "ssmt-dei:ApplicationOfSubmission",
          "values": ["Ordinary filing", "Court order filing", "Rectification filing with court order"]
        }
      },
      "requiredIf": { "qname": "ssmt-dei:ApplicationOfSubmission", "equals": "Rectification filing" },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt-dei:CourtOrderReferenceNumber",
      "label": "Court order reference number",
      "type": "CourtReferenceNumber",
      "ui": {
        "control": "text",
        "placeholder": "e.g. ROC1234567890123",
        "disabledWhen": {
          "field": "ssmt-dei:ApplicationOfSubmission",
          "values": ["Ordinary filing", "Rectification filing"]
        }
      },
      "requiredIfAny": [
        { "qname": "ssmt-dei:ApplicationOfSubmission", "equals": "Court order filing" },
        { "qname": "ssmt-dei:ApplicationOfSubmission", "equals": "Rectification filing with court order" }
      ],
      "validators": [{ "name": "pattern", "patternSource": "type:CourtReferenceNumber" }],
      "error": {
        "pattern": "Invalid format. Please enter a valid court order reference number (e.g., ROC1234567890123)"
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },

    {
      "qname": "ssmt-dei:DisclosureOfFinancialStatementsPreparationForCurrentSubmission",
      "label": "Disclosure of financial statements preparation for current submission",
      "type": "DisclosureOfFinancialStatementsPreparationForCurrentSubmission",
      "ui": { "control": "select", "enumSource": "type:DisclosureOfFinancialStatementsPreparationForCurrentSubmission" },
      "required": true,
      "validators": [{ "name": "required" }],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] },
      "triggers": [
        {
          "on": "change",
          "ifEquals": "Subsequent preparation of financial statements",
          "then": [
            { "action": "require", "targets": ["ssmt-dei:CompanyPreviousFinancialYearStartDate", "ssmt-dei:CompanyPreviousFinancialYearEndDate"] }
          ]
        }
      ],
      "error": {
        "required": "Please select disclosure of financial statements preparation for current submission."
      }
    },

    {
      "qname": "ssmt-dei:CompanyCurrentFinancialYearStartDate",
      "label": "Company current financial year start date",
      "type": "Date",
      "ui": { "control": "date", "placeholder": "Select one" },
      "required": true,
      "validators": [
        { "name": "required" },
        { "name": "lte", "other": "ssmt-dei:CompanyCurrentFinancialYearEndDate" }
      ],
      "error": {
        "required": "Please select Company's current financial year start date."
      },
      "ContextPolicy": { "periodTemplate": "I_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt-dei:CompanyCurrentFinancialYearEndDate",
      "label": "Company current financial year end date",
      "type": "Date",
      "ui": { "control": "date", "placeholder": "Select one" },
      "required": true,
      "validators": [
        { "name": "required" },
        { "name": "gte", "other": "ssmt-dei:CompanyCurrentFinancialYearStartDate" }
      ],
      "error": {
        "required": "Please select Company's current financial year end date."
      },
      "ContextPolicy": { "periodTemplate": "I_CUR", "allowedAxes": [] }
    },

    { "qname": "ssmt-dei:CompanyPreviousFinancialYearStartDate", "label": "Company previous financial year start date", "type": "Date", "ui": { "control": "date", "placeholder": "Select one" }, "requiredIf": { "qname": "ssmt-dei:DisclosureOfFinancialStatementsPreparationForCurrentSubmission", "equals": "Subsequent preparation of financial statements" }, "validators": [{ "name": "lte", "other": "ssmt-dei:CompanyPreviousFinancialYearEndDate" }], "ContextPolicy": { "periodTemplate": "I_CUR", "allowedAxes": [] }, "error": {
        "required": "Please select Company's previous financial year start date."
      } },
    { "qname": "ssmt-dei:CompanyPreviousFinancialYearEndDate",   "label": "Company previous financial year end date",   "type": "Date", "ui": { "control": "date", "placeholder": "Select one" }, "requiredIf": { "qname": "ssmt-dei:DisclosureOfFinancialStatementsPreparationForCurrentSubmission", "equals": "Subsequent preparation of financial statements" }, "validators": [{ "name": "gte", "other": "ssmt-dei:CompanyPreviousFinancialYearStartDate" }], "ContextPolicy": { "periodTemplate": "I_CUR", "allowedAxes": [] }, "error": {
        "required": "Please select Company's previous financial year start date."
      } },

    { "qname": "ssmt-dei:StatusOfCarryingOnBusinessDuringFinancialYear", "label": "Status of carrying on business during the financial year", "type": "TypeOfStatusOfCarryingOnBusiness", "ui": { "control": "select", "enumSource": "type:TypeOfStatusOfCarryingOnBusiness", "readonly": true, "defaultValue": "Carrying on business activities" }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },

    {
      "qname": "ssmt-dei:DisclosureOfFinancialStatementsAuditStatus",
      "label": "Disclosure of financial statements audit status",
      "type": "TypeOfAuditStatus",
      "ui": {
        "control": "select",
        "enumSource": "type:TypeOfAuditStatus",
        "readonly": true,
        "defaultValue": "Audited",
        "disabledWhen": {
          "field": "ssmt-dei:StatusOfCompany",
          "values": ["Public company"],
          "setValueTo": "Audited"
        }
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt-dei:AuditExemptionCategory",
      "label": "Audit exemption category",
      "type": "TypeOfAuditExemptionCategory",
      "ui": {
        "control": "select",
        "enumSource": "type:TypeOfAuditExemptionCategory"
      },
      "requiredIf": {
        "qname": "ssmt-dei:DisclosureOfFinancialStatementsAuditStatus",
        "equals": "Unaudited"
      },
      "ContextPolicy": {
        "periodTemplate": "D_CUR",
        "allowedAxes": []
      }
    },

    {
      "qname": "ssmt-dei:BasisOfAccountingStandardsAppliedToPrepareFinancialStatements",
      "label": "Basis of accounting standards applied to prepare the financial statements",
      "type": "TypeOfAccountingStandardsApplied",
      "ui": {
        "control": "select",
        "static": [
          "Malaysian Financial Reporting Standards",
          "Malaysian Private Entities Reporting Standards"
        ],
        "disabledWhen": {
          "field": "ssmt-dei:TypeOfCompany",
          "values": ["Company limited by guarantee"],
          "setValueTo": "Malaysian Financial Reporting Standards"
        },
        "lockWhen": {
          "field": "ssmt-dei:OriginOfCompany",
          "equals": "Incorporated outside Malaysia",
          "setValueTo": "Malaysian Financial Reporting Standards"
        }
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "Please select basis of accounting standards applied to prepare the financial statements"
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    { "qname": "ssmt-dei:DisclosureOfOtherAccountingStandardsApplied", "label": "Disclosure of other accounting standards applied", "type": "String", "ui": { "control": "text" }, "requiredIf": { "qname": "ssmt-dei:BasisOfAccountingStandardsAppliedToPrepareFinancialStatements", "equals": "Others" }, "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },

    {
      "qname": "ssmt-dei:TypeOfSubmission",
      "label": "Type of submission",
      "type": "TypeOfSubmission",
      "ui": {
        "control": "select",
        "enumSource": "type:TypeOfSubmission",
        "readonly": true,
        "showPlaceholder": false
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },

    { "qname": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements", "label": "Nature of financial statements", "type": "Enumeration", "ui": { "control": "select", "static": ["Consolidated", "Separate"] }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] },
      "crossSheet": [{ "whenEquals": "Consolidated", "suggestNavigateTo": ["SOFP", "SOPL", "SOCE", "SOCF"] }],"error": {
        "required": "Please select nature of financial statements."
      }
    },

    { "qname": "ssmt-dei:DescriptionOfPresentationCurrency", "label": "Description of presentation currency", "type": "TypeOfPresentationCurrency", "ui": { "control": "select", "enumSource": "type:TypeOfPresentationCurrency", "readonly": true, "defaultValue": "Malaysian Ringgit (MYR)" }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },
    { "qname": "ssmt-dei:DescriptionOfFunctionalCurrency",  "label": "Description of functional currency",  "type": "String", "ui": { "control": "select", "enumSource": "type:TypeOfFunctionalCurrency", "readonly": true, "defaultValue": "Malaysian Ringgit (MYR)" }, "required": false, "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },
    { "qname": "ssmt-dei:LevelOfRoundingUsedInFinancialStatements", "label": "Level of rounding used in financial statements", "type": "TypeOfRoundingOfUsedInPreparingFinancialStatements", "ui": { "control": "select", "enumSource": "type:TypeOfRoundingOfUsedInPreparingFinancialStatements", "readonly": true, "defaultValue": "Actuals" }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },

    { "qname": "ssmt-dei:NameAndVersionOfSoftwareUsedToGenerateXBRLFile", "label": "Name and version of software used to generate XBRL file", "type": "String", "ui": { "control": "text", "readonly": true, "defaultValue": "MBRS_Preparation_Tool v2.2" }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } },
    { "qname": "ssmt-dei:TaxonomyVersion", "label": "Taxonomy version", "type": "TaxonomyVersionType", "ui": { "control": "text", "readonly": true, "defaultValue": "SSMxT_2022v1.0" }, "required": true, "validators": [{ "name": "required" }], "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] } }
  ],
  "crossSheetDependencies": [
    { "source": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements", "targetRoles": ["SOFP","SOPL","SOCE","SOCF"], "reason": "Consolidated vs Separate defaults & required lines" }
  ],
  "_archived": {
    "_description": "Role1 (Phase 2 FilingInformation) renders a 28-field subset of the 33 entries in role0 (Phase 1 FilingPrerequisites). The following 9 role0 controls are omitted because they are Scope-of-Filing concerns rendered by role2 (ScopeOfFiling), not Filing-Info concerns. The backend's retrieve-mbrs-data FilingInfo payload still carries their values — role2 reads them directly from its own ScopeOfFiling state slot, so role1 does not duplicate them. See docs/sheet-specs/01_filing-info.md and docs/sheet-specs/02_scope-of-filing.md for the partition rationale.",
    "delegatedToRole2": [
      "ssmt:DisclosureOnWhetherCompanysSharesAreTradedOnAnyOfficialStockExchange",
      "ssmt:DisclosureOfWhetherCompanyRegulatedByBankNegaraMalaysiaAtFinancialYearEnd",
      "ssmt:DescriptionOnWhetherCompanyHadAppliedForAnyExemptionWaiverReliefOrExtensionOfTimeWithRegardToAnnualReturnOrFinancialStatementsAndReportsFromRegistrarOrMinister",
      "ssmt:MethodUsedForPreparingStatementOfFinancialPosition",
      "ssmt:MethodUsedForPreparingStatementOfProfitOrLoss",
      "ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome",
      "ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity",
      "ssmt:MethodUsedForPreparingStatementOfCashFlows",
      "ssmt:DisclosureOnWhetherComparativePeriodValuesAreRestated"
    ]
  }
}
